import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { TotemService } from '../totem.service';
import { environment } from 'src/environments/environment';
import { StorageService } from '../storage.service';

@Component({
  selector: 'app-cine-detalle',
  templateUrl: './cine-detalle.component.html',
  styleUrls: ['./cine-detalle.component.css']
})
export class CineDetalleComponent implements OnInit {
  id: number;
  pelicula: any;
  titulo: any;
  descripcion: any;
  sinopsis: string;
  horarios: any;
  horaActual: string;
  displayModal: boolean = false;

  constructor(private totemService: TotemService, private route: ActivatedRoute,
              private storageService: StorageService, public router: Router) { }

  ngOnInit() {
    this.getHoraActual();
    this.id = parseInt(this.route.snapshot.paramMap.get('id'));
    this.obtenerPelicula();
  }

  async obtenerPelicula() {
    await this.totemService.geteventos('es').toPromise().then((res: any) => {
      this.pelicula = res.find(peli => peli.eve_id === this.id);
      const descripcion = this.pelicula.descripcion.replace('<p>', '').replace('</p>', '').split('#');
      this.sinopsis = descripcion[0];
      const horarios = descripcion.slice(2,-1);
      this.titulo = JSON.parse(this.pelicula.titulo)
      this.horarios = this.ordenarHorarios(horarios);
    })    
  }

  getHoraActual() {
    const fecha = new Date();
    const hora = fecha.getHours().toString();
    let minuto = fecha.getMinutes().toString();
    if(minuto.length === 1)
      minuto = '0' + minuto;
    this.horaActual = hora + ':' + minuto;
  }

  ordenarHorarios(horarios: any) {
    let arregloFinal: Array<any> = [];
    horarios.forEach((horario: string) => {
      const dia = horario.split('_')[0];
      if(dia) {
        const funciones = horario.split('_')[1].split(' ');
        let tiposFuncion: Array<any> = [];
        let datosHorario: object;
        funciones.forEach((func: any) => {
          const hora = func.split('/')[0];
          const tipo = func.split('/')[1];

          if (tiposFuncion.indexOf(tipo) === -1) {
            tiposFuncion.push(tipo);
            datosHorario = {
              tipo: tipo,
              horas: [hora]
            };
            arregloFinal.push(datosHorario);
          } else {
            const n = tiposFuncion.indexOf(tipo);
            if (arregloFinal[n].horas.indexOf(hora) === -1) {
              arregloFinal[n].horas.push(hora);
            }
          }
        })
      }
    });
    
    arregloFinal.forEach((horario: any) => {
      horario.horas.sort();
      const tipos = horario.tipo.split(',');
      horario.tipo = tipos;
    })

    return arregloFinal;
  }

  openModal() {
    this.displayModal = true;
  }

  closeModal() {
    this.displayModal = false;
  }

  async iniciarRuta() {
    // await this.storageService.setDestino(environment.codCine.toString(), 'tiendas');
    this.router.navigate(['mapa/0/2558/tiendas/0']);
  }
}
